import { userService } from '../services';
import { RD_AUTH_TOKEN } from '@/constants/settings'
import router from '@/router/router'

const token = sessionStorage.getItem('rdToken');
const initialState = token ? { status: { loggedIn: true }, token } : { status: {}, token: null };

const getters = {
    auth(initialState) {
        return initialState
    }
}

const actions = {
    login({ dispatch, commit }, { email, password }) {
        commit('loginRequest', { email });

        userService.logIn(email, password)
            .then(
                token => {
                    sessionStorage.setItem(RD_AUTH_TOKEN, token.data.tokenAuth.token)
                    commit('loginSuccess', token);
                    var t = [];
                    t.message = "Erfolgreich eingeloggt!";
                    dispatch('notify/success', t, { root: true });
                    router.push({ name: 'Dashboard' });
                   
                },
                error => {
                    sessionStorage.removeItem(RD_AUTH_TOKEN)
                    commit('loginFailure', error);
                    dispatch('notify/error', error, { root: true });
                }
            );
    },
    logout({ dispatch, commit }) {
        userService.logOut().then(
            logout => {
                console.log(logout);
                sessionStorage.removeItem(RD_AUTH_TOKEN)
                commit('logout', {});
                var t = [];
                t.message = "Erfolgreich ausgeloggt!";
                dispatch('notify/success', t, { root: true });
                router.push({ name: 'Login' });
            },
            error => {
                sessionStorage.removeItem(RD_AUTH_TOKEN)
                commit('logout', error);
                dispatch('notify/error', error, { root: true });
                router.push({ name: 'Login' });
            }
        );
        commit('logout');
    }
};

const mutations = {
    loginRequest(state, token) {
        state.status = { loggingIn: true };
        state.token = token;
    },
    loginSuccess(state, token) {
        state.status = { loggedIn: true };
        state.token = token;
    },
    loginFailure(state) {
        state.status = {};
        state.token = null;
    },
    logout(state) {
        state.status = {};
        state.token = null;
    }
};

export const authentification  = {
    namespaced: true,
    state: initialState,
    actions,
    mutations,
    getters,
};